// src/utils/zegoApi.js  (copy this same file into BOTH the website and the doctor panel)

const BASE_URL = "https://api.elthiumhealth.com/api/zego";

// Add whichever key your app stores the login token under.
const TOKEN_KEYS = ["token", "authToken", "accessToken", "doctorToken", "staffToken"];

const getAuthToken = () => {
  for (const key of TOKEN_KEYS) {
    const v = localStorage.getItem(key);
    if (v) return v.replace(/^"|"$/g, "");
  }
  return "";
};

const buildHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) headers.Authorization = /^Bearer\s/i.test(token) ? token : `Bearer ${token}`;
  return headers;
};

const request = async (path, { method = "GET", body, keepalive = false } = {}) => {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: buildHeaders(),
    body: body ? JSON.stringify(body) : undefined,
    keepalive,
  });

  let data = null;
  try {
    data = await res.json();
  } catch (_) {}

  if (!res.ok || data?.success === false) {
    throw new Error(data?.message || `Request failed (${res.status})`);
  }
  return data;
};

/** Records that the current user (doctor or staff, decided by token) joined the room. */
export const joinRoom = (bookingId) =>
  request("/joinroom", { method: "POST", body: { bookingId } });

/** Booking + doctor + staff + room/session details. */
export const getRoomDetails = (bookingId) =>
  request(`/roomdetails?bookingId=${encodeURIComponent(bookingId)}`);

/** Closes the current user's session. keepalive lets it survive tab close / refresh. */
export const endRoom = (bookingId, { keepalive = false } = {}) =>
  request("/endroom", { method: "POST", body: { bookingId }, keepalive });

/** true if `role` ("doctor" | "staff") currently has an open (not left) session. */
export const hasOpenSession = (details, role) =>
  !!details?.room?.sessions?.some((s) => s.role === role && !s.leftAt);